module.exports = __webpack_public_path__ + "3efc376bead2b118e5bf9a0f50007799.svg";